<section>
  <div class="container-fluid">
    <div class="row">
      <!-- <button mat-button (click)="openDialog()">Open dialog</button> -->
      <div class="col text-center">
        <div style="position: absolute">
          <a (click)="backClicked()" style="color: #fff"
            ><img
              src="/assets/event/exh/3d/white.svg"
              style="width: 26px; margin: 15px; background-color: #000"
          /></a>
          &nbsp;&nbsp;&nbsp;
          <a [routerLink]="['', 'audi']" style="color: #fff"
            ><img src="/assets/event/live1.gif" style="width: 80px"
          /></a>
          <!-- <a
              class="btn btn-success float-left"
              style="color: #fff; background-color: #28a745"
              href="https://api.whatsapp.com/send?phone=00971529115152"
              target="_blank"
              >Whatsapp
            </a> -->
        </div>
        <div class="d_1241">
          <img
            src="assets/event/exh/pfizer_booth.png"
            alt="Workplace"
            usemap="#workmap"
            width="1241px"
            height="700px"
          />
          <map name="workmap">
            <!-- <area shape="rect" coords="323,265,453,338" alt="vedio" /> -->
          </map>
        </div>
        <div class="d_768">
          <img
            src="assets/event/exh/pfizer_booth_768.png"
            alt="Workplace"
            usemap="#workmap_768"
            width="768px"
            height="433px"
          />

          <map name="workmap_768"> </map>
        </div>
        <div class="d_320">
          <img
            src="assets/event/exh/pfizer_booth_320.png"
            alt="Workplace"
            usemap="#workmap_320"
            width="320px"
            height="181px"
          />

          <map name="workmap_320"> </map>
        </div>
      </div>
    </div>

    <!-- Container end -->
  </div>
</section>
